/* eslint-disable import/no-anonymous-default-export */
import { FETCHTOTALINCOME } from "../constants/actionTypes";

export default (totalIncome = 0, action) => {
  switch (action.type) {
    case FETCHTOTALINCOME:
      return action.payload;
    default:
      return totalIncome;
  }
};
